export default __webpack_public_path__ + "static/media/appMan.d151eb98.svg";